import React from 'react';
import styled from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import YesNoRadioGroup from '../YesNoRadioGroup';

export const CovidScreenRequirement = ({
    text,
    dataTest,
    onRadioChange,
    hasError,
}) => {
    return (
        <FormRow data-test={dataTest}>
            <FormLabel>{text}</FormLabel>
            <YesNoRadioGroup onChange={onRadioChange} hasError={hasError} />
        </FormRow>
    );
};

const FormLabel = styled.div`
    font: 15px/24px ${FontFamily.SharpSansSemibold};
    padding-bottom: 4px;
`;

export default CovidScreenRequirement;
